import { c as _c } from "react/compiler-runtime";
import * as RadixSelect from '@radix-ui/react-select';
import { cx } from 'class-variance-authority';
import ScrollButton from './scroll-button';
type CustomContentProps = {
  children: React.ReactNode;
  ariaLabel?: string;
  contentProps?: import('@radix-ui/react-select').SelectContentProps;
  hideScrollButtons?: boolean;
};
const CustomContent = t0 => {
  const $ = _c(13);
  const {
    children,
    ariaLabel,
    contentProps,
    hideScrollButtons: t1
  } = t0;
  const hideScrollButtons = t1 === undefined ? false : t1;
  const t2 = `${ariaLabel} options`;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = cx("relative z-50", "border border-tertiary", "rounded overflow-auto mr-2", "bg-elevated shadow-md", "transition-shadow duration-200", "data-[state=open]:animate-scaleIn", "max-w-[min(28rem,calc(100vw-2rem))]", "max-h-[min(22rem,60dvh)]");
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== hideScrollButtons) {
    t4 = !hideScrollButtons && <ScrollButton direction="up" />;
    $[1] = hideScrollButtons;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== children) {
    t5 = <RadixSelect.Viewport>{children}</RadixSelect.Viewport>;
    $[3] = children;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== hideScrollButtons) {
    t6 = !hideScrollButtons && <ScrollButton direction="down" />;
    $[5] = hideScrollButtons;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== contentProps || $[8] !== t2 || $[9] !== t4 || $[10] !== t5 || $[11] !== t6) {
    t7 = <RadixSelect.Content translate="no" aria-label={t2} {...contentProps} className={t3}>{t4}{t5}{t6}</RadixSelect.Content>;
    $[7] = contentProps;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
};
export default CustomContent;